export class EditorialItemModel {
  public readonly id: string;
  public readonly text?: string;
  public readonly title?: string;
  public readonly uitkIconName?: string;
  public readonly view?: string;

  /* istanbul ignore next */
  public constructor(id: string, text?: string, title?: string, uitkIconName?: string, view?: string) {
    this.id = id;
    this.text = text;
    this.title = title;
    this.uitkIconName = uitkIconName;
    this.view = view;
  }
}

export default EditorialItemModel;
